/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */


import React, { useEffect, useCallback, useState } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { Tab, Box } from "@mui/material";
import { TabContext, TabList } from '@mui/lab';
import { useDispatch, useSelector } from "react-redux";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { CategoryView } from "./CategoryView";
import { ProductView } from "./ProductView";
import customStyles from "../../../../../assets/styles/customStyles";
import actions from "../../redux/actions";
import clsx from "clsx";
import { useParams, Link } from "react-router-dom";


const UniversalCatalogueView = (props) => {
    const { catalogueDetails, categoryDetails, productDetails } = useSelector(state => state.younoteAdminProductReducer);
    const dispatch = useDispatch();

    const { catalogueId } = useParams();
    const [value, setValue] = useState(parseInt(catalogueId));
    const [viewData, setViewData] = useState('catalogue');
    const [categoryDetailsView, setCategoryDetailsView] = useState([]);
    const [tabContent, setTabContent] = useState([]);
    const [customCatalogue, setCustomCatalogue] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [viewDataLoad, setViewDataLoad] = useState(false);
    const [viewBread, setViewBread] = useState(false);
    const [currentId, setCurrentId] = useState([]);
    const tab = 1;

    useEffect(() => {
        loadTasks();
    }, []);

    useEffect(() => {
        if (catalogueDetails.length > 0) {
            let a = catalogueDetails.filter((el) => { return el.id === parseInt(catalogueId) });
            if (a && a?.length !== 0) {
                handleParentClick('catalogue', a[0]);
                setViewDataLoad(true);
            }
        }
        setTabContent(catalogueDetails);
    }, [catalogueDetails]);

    useEffect(() => {
        setTimeout(() => {
            setViewDataLoad(true);
        }, 500);
        if (viewBread) {
            setTabContent(categoryDetails);
            setViewBread(false);
        } else {
            setCategoryDetailsView(categoryDetails);
        }
    }, [categoryDetails, productDetails]);

    const handleParentClick = (type, data, tabClick = true) => {
        let filter = '';
        setViewDataLoad(false);
        setViewBread(false);
        if (type === 'catalogue') {
            setCustomCatalogue(data);
            if (tabClick) {
                setTabContent(catalogueDetails);
            }
            filter = { ["and"]: [{ catalogueId: data.id }, { parentId: null }] };
            setCurrentId([]);
        } else {
            setCategoryId(data.id);
            if (tabClick) {
                setTabContent(categoryDetails);
            }
            filter = { ["and"]: [{ parentId: data.id }] };
        }

        if (data.hasCategories || data.hasSubCategories) {
            setViewData('category');
            dispatch({
                type: actions.CATEGORY_DETAILS_START,
                url: 'product-categories',
                filter: {
                    where: filter
                }
            });
        } else {
            setViewData('product');
            if (data.catalogueName) {
                filter = { ["and"]: [{ catalogueId: data.id }] };
            } else {
                filter = { ["and"]: [{ categoryId: data.id }] };
            }
            dispatch({
                type: actions.PRODUCT_DETAILS_START,
                filter: {
                    where: filter
                }
            });
        }

        if (type === 'category') {
            let newSelected = [];
            if (tabClick) {
                const selectedIndex = currentId.findIndex((el) => el?.id === data?.id);
                if (selectedIndex === -1) {
                    newSelected = currentId.concat(data);
                }
                setCurrentId(newSelected);
            } else {
                const selectedIndex = currentId.findIndex((el) => el?.id === data?.id);
                if (selectedIndex === -1) {
                    currentId[currentId.length - 1] = data;
                }
            }
        }

        setValue(data.id);
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: actions.CATALOGUE_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
    });

    const handleChange = (event, newValue) => {
        let a = [];
        a = tabContent.filter((el) => { return el.id === newValue });
        handleParentClick(`${a[0]?.catalogueName ? 'catalogue' : 'category'}`, a[0], false);
    };

    const handleBreadClick = (data) => {
        const selectedIndex = currentId.findIndex((el) => el?.id === data?.id);
        setViewDataLoad(false);
        currentId.length = selectedIndex + 1;

        let d = currentId[selectedIndex];
        if (d) {
            setValue(d?.id);
        }

        if (currentId.length > 1) {
            if (data.hasSubCategories) {
                setViewBread(true);
                setViewData('category');
                dispatch({
                    type: actions.CATEGORY_DETAILS_START,
                    url: 'product-categories',
                    filter: {
                        where: { ["and"]: [{ parentId: data.parentId }] }
                    }
                });
            }
            setTimeout(() => {
                if (data.hasSubCategories) {
                    setViewBread(false);
                    setViewData('category');
                    dispatch({
                        type: actions.CATEGORY_DETAILS_START,
                        url: 'product-categories',
                        filter: {
                            where: { ["and"]: [{ parentId: data.id }] }
                        }
                    });
                }
            }, 200)
        } else {
            if (data.hasSubCategories && data.parentId === null) {
                setViewBread(true);
                setViewData('category');
                dispatch({
                    type: actions.CATEGORY_DETAILS_START,
                    url: 'product-categories',
                    filter: {
                        where: { ["and"]: [{ catalogueId: data.catalogueId }, { parentId: null }] }
                    }
                });
            }
            setTimeout(() => {
                if (data.hasSubCategories && data.parentId === null) {
                    setViewBread(false);
                    dispatch({
                        type: actions.CATEGORY_DETAILS_START,
                        url: 'product-categories',
                        filter: {
                            where: { ["and"]: [{ parentId: data.id }] }
                        }
                    });
                }
            }, 200)
        }


    }


    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Younote Admin'}
                links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Universal Catalogue', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.universalCatalogue)}>
                <PrimaryCard
                    title={'Universal Catalogue'}
                    component={
                        <div className={clsx(classes.catalogue, categoryId)}>
                            <div className={classes.subBreadcrumb}>
                                <Link to={`/younote-admin/common/universal-catalogue`}>Home</Link>
                                {
                                    customCatalogue !== '' && <> / <Link to={`#`} onClick={() => handleParentClick('catalogue', customCatalogue)}>{customCatalogue?.catalogueName}</Link></>
                                }
                                {
                                    currentId.length > 0 && currentId.map((data, i) => (
                                        <> / <Link to={`#`} onClick={() => handleBreadClick(data)}>{data?.categoryName}</Link></>
                                    ))
                                }
                            </div>
                            <TabContext value={value}>
                                <Box id={tab} className={clsx(classes.tabDesign, classes.margin35t)}>
                                    <TabList className={classes.universalScroll} onChange={(e, newValue) => handleChange(e, newValue)}>
                                        {
                                            tabContent.length > 0 && tabContent.map((data, i) => (
                                                <Tab key={i}
                                                    className={clsx(classes.Bordertab_1)}
                                                    label={data?.catalogueName || data?.categoryName}
                                                    value={data.id} />
                                            ))
                                        }
                                    </TabList>
                                </Box>
                            </TabContext>
                            {
                                viewDataLoad ? <>
                                    {
                                        viewData === 'category' ?
                                            <div className={classes.categoryRow}> <CategoryView details={categoryDetailsView}
                                                handleParentClick={(type, data) => handleParentClick(type, data)} /> </div>
                                            : <ProductView details={productDetails} />
                                    }
                                </> : <div className={classes.loadMoreCircle}></div>
                            }
                        </div>

                    }
                />
            </div>
        </React.Fragment>
    )
}


export default UniversalCatalogueView;